import { BasicFacetTermV2 } from '@ravago/shared/page-data/models/elastic';

export const facetsObjectToList = (facetsObj: Record<string, BasicFacetTermV2[]>) =>
   Object.entries(facetsObj)
      .map(([facetName, terms]) => ({
         facetName,
         terms: terms
      }))
      .filter((value) => value.terms.length > 0);
